var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeleteRed = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33317 4.6665L3.8712 13.813C3.97514 15.58 4.02711 16.4635 4.40423 17.134C4.73622 17.7242 5.2401 18.1993 5.8488 18.4961C6.54027 18.8332 7.42529 18.8332 9.19533 18.8332H10.8043C12.5744 18.8332 13.4594 18.8332 14.1509 18.4961C14.7596 18.1993 15.2635 17.7242 15.5954 17.134C15.9726 16.4635 16.0245 15.58 16.1285 13.813L16.6665 4.6665M3.33317 4.6665H1.6665M3.33317 4.6665H16.6665M16.6665 4.6665H18.3332M8.33317 8.83317V14.6665M11.6665 8.83317V12.1665M13.3332 4.6665L12.9557 3.53405C12.7918 3.04229 12.7098 2.7964 12.5578 2.61462C12.4235 2.45409 12.2511 2.32983 12.0564 2.25324C11.8359 2.1665 11.5767 2.1665 11.0583 2.1665H8.94136C8.42299 2.1665 8.16381 2.1665 7.94328 2.25324C7.74854 2.32983 7.57614 2.45409 7.44189 2.61462C7.28987 2.7964 7.20791 3.04229 7.04399 3.53405L6.6665 4.6665",
    stroke: "#D12D36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeleteRed);
export default ForwardRef;